module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAOklEQVQ4y2NgGBTgPwwgMeF8bGJwJrIBMMXIGnDx4Vqo6gJsAJsBKNIwA5CdRgKmogEUe2E0Goc4AACc9eIsEg/ojAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GE.png
// module id = 1145
// module chunks = 0